export default __webpack_public_path__ + "static/media/information-button.df517275.png";